module.exports = __webpack_public_path__ + "img/fb06a64cecd228637e21d05bf7dcec42.png";